import { useMemo } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { analyticsTabs } from 'modules/Analytics/model/analyticsTabs'

import { Tabs } from 'shared/ui/Tabs'

import './AnalyticsNavigation.css'

const AnalyticsNavigation = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const activeKey = useMemo(() => {
    return location.pathname.split('/').filter(Boolean).at(-1)
  }, [pathname])

  const onTabClick = (key: string) => {
    navigate(key)
  }

  return (
    <div>
      <Tabs
        tabBarStyle={{ flexWrap: 'nowrap', overflowX: 'auto' }}
        onTabClick={onTabClick}
        activeKey={activeKey}
        items={analyticsTabs}
        className="analyticsTabs"
      />
    </div>
  )
}

export default AnalyticsNavigation
